import { render, staticRenderFns } from "./iframe_config.vue?vue&type=template&id=f3210852&"
import script from "./iframe_config.vue?vue&type=script&lang=js&"
export * from "./iframe_config.vue?vue&type=script&lang=js&"
import style0 from "./iframe_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports